import React, { createContext, ReactNode, useContext, useState } from 'react';

interface MoopShellContextType {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
}

const MoopShellContext = createContext<MoopShellContextType>({
  sidebarCollapsed: false,
  toggleSidebar: () => {},
});

export const MoopShellProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => setSidebarCollapsed((prev) => !prev);

  return <MoopShellContext.Provider value={{ sidebarCollapsed, toggleSidebar }}>{children}</MoopShellContext.Provider>;
};

export const useMoopShell = (): MoopShellContextType => useContext(MoopShellContext);

export default MoopShellContext;
